import { ColumnConfig } from '@/components/table/Table';
import { Badge } from '@/components';
import { LogisticOperator } from '../models';
import { LogisticOperatorStatus, LogisticOperatorStatusLabels } from '../enums';

const statusColors: Record<
  LogisticOperatorStatus,
  { backgroundColor: string; ballColor: string; textColor: string }
> = {
  [LogisticOperatorStatus.CREATED]: {
    backgroundColor: '#E8F5E9',
    ballColor: '#2E7D32',
    textColor: '#2E7D32',
  },
  [LogisticOperatorStatus.ACTIVE]: {
    backgroundColor: '#E8F5E9',
    ballColor: '#2E7D32',
    textColor: '#2E7D32',
  },
  [LogisticOperatorStatus.INACTIVE]: {
    backgroundColor: '#FFEBEE',
    ballColor: '#C62828',
    textColor: '#C62828',
  },
};

export const logisticOperatorsTableColumns: ColumnConfig[] = [
  {
    label: 'ID',
    field: 'externalId',
    render: (value: string, row: LogisticOperator) => {
      return value || `ID-${row.id?.slice(-8) || 'N/A'}`;
    },
  },
  {
    label: 'Nombre',
    field: 'fullName',
  },
  {
    label: 'Razón social',
    field: 'businessName',
  },
  {
    label: 'Casa matriz',
    field: 'headquarter',
    render: (value: boolean) => (value ? 'Sí' : 'No'),
  },
  {
    label: 'Estado',
    field: 'status',
    render: (value: LogisticOperatorStatus) => {
      const colors =
        statusColors[value] || statusColors[LogisticOperatorStatus.ACTIVE];
      const label = LogisticOperatorStatusLabels[value] || value;
      return <Badge value={label} {...colors} />;
    },
  },
];
